import { render, staticRenderFns } from "./Registrierung.vue?vue&type=template&id=109d2840&"
import script from "./Registrierung.vue?vue&type=script&lang=js&"
export * from "./Registrierung.vue?vue&type=script&lang=js&"
import style0 from "./Registrierung.vue?vue&type=style&index=0&id=109d2840&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports